export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["NO_CONNECTION"] = "NO_CONNECTION";
    ConnectionState["CONNECTING"] = "CONNECTING";
    ConnectionState["CONNECTED"] = "CONNECTED";
    ConnectionState["RECONNECTING"] = "RECONNECTING";
    ConnectionState["DISCONNECTED"] = "DISCONNECTED";
})(ConnectionState || (ConnectionState = {}));
export var ChatState;
(function (ChatState) {
    ChatState["UNAVAILABLE"] = "UNAVAILABLE";
    ChatState["READY"] = "READY";
    ChatState["ON_HOLD"] = "ON_HOLD";
    ChatState["ACTIVE"] = "ACTIVE";
    ChatState["TRANSFERRING"] = "TRANSFERRING";
    ChatState["COMPLETE"] = "COMPLETE";
    ChatState["ERROR"] = "ERROR";
})(ChatState || (ChatState = {}));
//# sourceMappingURL=events-models.js.map